'use client';

import VoiceflowChatContent from '@/components/core/voiceflowChat';

export default function BriefPage() {
  return (
    <div className="flex h-screen w-screen items-center justify-center overflow-hidden bg-white pt-[76px] [&_.rounded-2xl]:rounded-xl [&_.rounded-2xl]:border [&_.rounded-2xl]:border-was-ink/8 [&_.rounded-2xl]:shadow-[0_24px_56px_-24px_rgba(19,14,27,0.25)]">
      <VoiceflowChatContent />
    </div>
  );
}
